import React, { useState } from 'react';
import { PollyEnv } from '../../types';
import { apiService } from '../../services/api';
import '../shared.css';
import './AuthForm.css';

interface AuthFormProps {
  onAuthenticated: () => void;
}

const AuthForm: React.FC<AuthFormProps> = ({ onAuthenticated }) => {
  const [pollyEnv, setPollyEnv] = useState<PollyEnv>('devpolly');
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!apiKey.trim()) {
      setError('API Key is required');
      return;
    }

    try {
      apiService.initialize(pollyEnv, apiKey);

      // Test the connection by fetching KGs
      await apiService.listKGs();

      // Fetch user information to get user_id
      try {
        const userInfo: any = await apiService.getUserInfo();

        // Extract user_id from the response
        const userId = userInfo.data?.attributes?.id ||
                      userInfo.data?.id ||
                      userInfo.id ||
                      userInfo.user_id;

        if (userId) {
          sessionStorage.setItem('userId', userId);
        } else {
          console.warn('Could not extract user_id from user info response');
        }
      } catch (userErr) {
        console.warn('Failed to fetch user info:', userErr);
        // Don't fail authentication if user info fetch fails
      }

      // Store credentials in localStorage
      localStorage.setItem('pollyEnv', pollyEnv);
      localStorage.setItem('apiKey', apiKey);

      onAuthenticated();
    } catch (err: any) {
      setError(err.response?.data?.message || 'Authentication failed. Please check your credentials.');
      console.error('Authentication error:', err);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h1>KG Manager</h1>
        <p className="auth-subtitle">Authentication Required</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="pollyEnv">Polly Environment</label>
            <select
              id="pollyEnv"
              value={pollyEnv}
              onChange={(e) => setPollyEnv(e.target.value as PollyEnv)}
              className="form-control"
            >
              <option value="devpolly">Development (devpolly)</option>
              <option value="testpolly">Testing (testpolly)</option>
              <option value="polly">Production (polly)</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="apiKey">Polly API Key</label>
            <input
              id="apiKey"
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              placeholder="Enter your API key"
              className="form-control"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="tab-btn tab-btn--primary auth-submit-btn">
            Connect
          </button>
        </form>
      </div>
    </div>
  );
};

export default AuthForm;
